import React, { useContext, useState } from "react";
import Box from "@mui/material/Box";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Modal,
  Typography,
} from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { TheContext } from "../Context";
import { Stack } from "@mui/system";
import "../App.css";

const deleteModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function CelebrityItemView({ celeb }) {
  const { expandedId, changeExpandedId, setEditCelebId, deleteCeleb } =
    useContext(TheContext);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleEdit = () => {
    if (celeb.age < 18) {
      console.log("You can only edit the user if the user is an adult");
      return;
    }
    setEditCelebId(celeb.id);
  };

  const handleDeleteModalClose = () => setOpenDeleteModal(false);
  const handleDeleteClick = () => setOpenDeleteModal(true);
  const handleDeleteConfirm = () => deleteCeleb(celeb.id);

  return (
    <Accordion
      key={celeb.id}
      expanded={expandedId === celeb.id}
      onChange={changeExpandedId(celeb.id)}
      sx={{ borderRadius: 5, marginTop: 2 }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <img
          src={celeb.picture}
          alt={celeb.name}
          style={{ borderRadius: 50 }}
        ></img>
        <Typography sx={{ m: 3, fontWeight: "bold" }}>{celeb.name}</Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          m: 2,
        }}
      >
        <div>
          <div className="label">Age</div>
          {celeb.age}
        </div>
        <div>
          <div className="label">Gender</div>
          <div className="capitalize">{celeb.gender}</div>
        </div>
        <div>
          <div className="label">Country</div>
          {celeb.country}
        </div>
      </AccordionDetails>

      <AccordionDetails>
        <div className="label">Discription</div>
        {celeb.description}
      </AccordionDetails>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row-reverse",
          m: 1,
        }}
      >
        <Button onClick={handleEdit}>
          <ModeEditOutlineOutlinedIcon />
        </Button>
        <Button onClick={handleDeleteClick} sx={{ color: "red" }}>
          <DeleteOutlineOutlinedIcon />
        </Button>
      </Box>
      <Modal
        className="delete-modal"
        open={openDeleteModal}
        onClose={handleDeleteModalClose}
        aria-labelledby="Delete confirm modal"
        aria-describedby="Delete confirm modal"
      >
        <Box sx={deleteModalStyle}>
          <Typography sx={{ mt: 2 }}>
            Are you sure you want to delete <b>{celeb.name}</b>?
          </Typography>
          <Stack direction="row-reverse" spacing={2} marginTop={2}>
            <Button onClick={handleDeleteModalClose} variant="outlined">
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleDeleteConfirm}
              color="error"
              sx={{ m: 1 }}
            >
              Delete
            </Button>
          </Stack>
        </Box>
      </Modal>
    </Accordion>
  );
}
